import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const forgotPasswordSchema = z.object({
  email: z.string().email(),
  recaptchaToken: z.string().optional(),
});

export class ForgotPasswordDto extends createZodDto(forgotPasswordSchema) {}
